import { createMemoryHistory, createRouter } from 'vue-router'
import AuthLogin from '@/components/authentication/auth-login.vue';
import ResetPasswordTemporary from '@/components/user/reset-password-temporary.vue';
import DashboardIndex from '@/components/dashboard/dashboard-index.vue';
import ClientFile from '@/components/client/client-file.vue';
import ListNotification from '@/components/notification/list-notification.vue';
import ClientPf from '@/components/client/client-pf.vue';
import ClientPj from '@/components/client/client-pj.vue';
import ClientCertificate from '@/components/client/client-certificate.vue';
import ClientFiscal from '@/components/client/client-fiscal.vue';
import ClientStructureCorporate from '@/components/client/client-structure-corporate.vue';
import ClientService from '@/components/client/client-service.vue';
import ListReceivableAccount from '@/components/financial/list-receivable-account.vue';
import acceptTermUseFilter from '@/middleware/acceptTermUseFilter';
import authMiddleware from '@/middleware/auth';
import AcceptTermUse from '@/components/user/aceppt-term-use.vue';
import changePasswordTemporary from '@/middleware/passwordTemporary';
import ResetPassword from '@/components/authentication/reset-password.vue';


const routes = [

  //Autenticação
  { path: '/login', component: AuthLogin, meta: { hideMenu: true } },
  { path: '/resetPassword', component: ResetPassword, meta: { hideMenu: true } },


  //Redefinir senha temporária
  { path: '/change-password-temporary', component: ResetPasswordTemporary, meta: { requiresAuth: true, acceptTermUse: true, hideMenu: true } },

  //Dashboard
  { path: '/', component: DashboardIndex, meta: { requiresAuth: true, acceptTermUse: true, resetPasswordTemporary: true } },

  //Notificações
  { path: '/notification-user', component: ListNotification, meta: { requiresAuth: true, acceptTermUse: true } },

  //Dados do cliente
  { path: '/client/:id', component: ClientPf, name: "client_pf", meta: { requiresAuth: true, acceptTermUse: true, resetPasswordTemporary: true } },
  { path: '/client/:id', component: ClientPj, name: "client_pj", meta: { requiresAuth: true, acceptTermUse: true, resetPasswordTemporary: true } },
  { path: '/client/:id/certificate', component: ClientCertificate, name: "client_certificate", meta: { requiresAuth: true, acceptTermUse: true, resetPasswordTemporary: true } },
  { path: '/client/:id/fiscal', component: ClientFiscal, name: "client_fiscal", meta: { requiresAuth: true, acceptTermUse: true, resetPasswordTemporary: true } },
  { path: '/client/:id/structureCorporate', component: ClientStructureCorporate, name: "client_structure_corporate", meta: { requiresAuth: true, acceptTermUse: true, resetPasswordTemporary: true } },
  { path: '/client-file', component: ClientFile, name: "client_file", meta: { requiresAuth: true, acceptTermUse: true, resetPasswordTemporary: true } },
  { path: '/client/:id/service', component: ClientService, name: "client_service", meta: { requiresAuth: true, acceptTermUse: true, resetPasswordTemporary: true } },

  //Financeiro
  { path: '/financial/:id', component: ListReceivableAccount, name: "financial", meta: { requiresAuth: true, acceptTermUse: true, resetPasswordTemporary: true } },

  //Aceitar termos de uso
  { path: '/accept-term-use', component: AcceptTermUse, meta: { hideMenu: true } },

];

const router = createRouter({ history: createMemoryHistory(), routes });

router.beforeEach(async (to, from, next) => { await authMiddleware(to, from, next); });

router.beforeEach(async (to, from, next) => { await changePasswordTemporary(to, from, next); });

router.beforeEach(async (to, from, next) => { await acceptTermUseFilter(to, from, next); });


export default router;